<div class="container">
    <app-section-header
        title="{{ account?.name }}"
        subTitle="Accounts"
        [actionsTemplate]="actionsTemplate"
        iconName="goBack"
        [mainAdditionalTemplate]="statusTemplate"
    >
        <ng-template #statusTemplate>
            @if (!isActive) {
                <lib-status-indicator
                    [iconName]="'archived'"
                    [colorType]="'error'"
                    [text]="'Archived'"
                ></lib-status-indicator>
            }
        </ng-template>

        <ng-template #actionsTemplate>
            <div class="actions">
                @if (currentTab === 'Overview') {
                    <button class="primary-btn" (click)="onEditAccount()">Edit</button>
                }
                <app-kebab-menu>
                    @if (isActive) {
                        <button role="menuitem" class="resetStyles" (click)="archiveAccount()">Archive</button>
                    } @else {
                        <button role="menuitem" class="resetStyles" (click)="restoreAccount()">Restore</button>
                    }
                </app-kebab-menu>
            </div>
        </ng-template>
    </app-section-header>

    <div class="tabGroup">
        <lib-tab-view
            [(currentTab)]="currentTab"
            (currentTabChange)="tabChange($event)"
            alignment="start"
            separation="wide"
        >
            <lib-tab-item tabName="Overview" [bodyTemplate]="overviewTab">
                <ng-template #overviewTab>
                    <div class="tab" #scrollable>
                        <app-accounts-single-overview
                            [account]="account"
                            [isReadOnly]="true"
                        ></app-accounts-single-overview>
                    </div>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Companies" [bodyTemplate]="companiesTab" [headerTemplate]="headerTemplate">
                <ng-template #companiesTab>
                    <app-accounts-single-companies
                        [account]="account"
                        (AccountChange)="handleAccountChange()"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-accounts-single-companies>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Opportunities" [bodyTemplate]="opportunitiesTab" [headerTemplate]="headerTemplate">
                <ng-template #opportunitiesTab>
                    <app-accounts-single-opportunities [accountId]="accountId"></app-accounts-single-opportunities>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Contacts" [bodyTemplate]="contactsTab" [headerTemplate]="headerTemplate">
                <ng-template #contactsTab>
                    <app-accounts-single-contacts
                        [account]="account"
                        (AccountChange)="handleAccountChange()"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-accounts-single-contacts>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Buildings" [bodyTemplate]="buildingsTab" [headerTemplate]="headerTemplate">
                <ng-template #buildingsTab>
                    <app-accounts-single-buildings
                        [account]="account"
                        (AccountChange)="handleAccountChange()"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-accounts-single-buildings>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Activity Log" [bodyTemplate]="activityLogTab">
                <ng-template #activityLogTab>
                    <app-activity-log-grid [entityId]="accountId" [entityTypeId]="entityTypeId"></app-activity-log-grid>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Notes" [bodyTemplate]="notesTab" [headerTemplate]="headerTemplate">
                <ng-template #notesTab>
                    <app-notes
                        [entityTypeId]="entityTypeId"
                        [entityId]="$safeNavigationMigration(account?.id)"
                        [entityName]="$safeNavigationMigration(account?.name)"
                        [organizationId]="$safeNavigationMigration(account?.organizationId)"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-notes>
                </ng-template>
            </lib-tab-item>

            <ng-template #headerTemplate let-tab="tab">
                <lib-counter-badge
                    [label]="tab.tabName()"
                    [count]="tabsCounters[tab.tabName()] || 0"
                ></lib-counter-badge>
            </ng-template>
        </lib-tab-view>
    </div>
</div>
